import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22">
    <path
      stroke="#057953"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M17.078 6.555c.037.559-.009 1.191-.119 1.897l-.67 4.3c-.568 3.584-2.227 4.794-5.81 4.234l-4.3-.678c-1.238-.192-2.19-.522-2.888-1.017-1.329-.926-1.714-2.448-1.347-4.795l.678-4.299c.569-3.584 2.228-4.794 5.812-4.235l4.3.679c2.877.449 4.225 1.622 4.344 3.914"></path>
    <path
      stroke="#057953"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m18.79 12.348-1.375 4.134c-1.146 3.447-2.98 4.364-6.426 3.218l-4.134-1.375c-2.08-.688-3.236-1.641-3.566-3.034.697.495 1.65.825 2.888 1.017l4.299.678c3.584.56 5.243-.65 5.811-4.235l.67-4.299c.11-.706.155-1.338.119-1.897 2.19 1.164 2.667 2.924 1.714 5.793M7.552 8.23a1.595 1.595 0 1 0 0-3.19 1.595 1.595 0 0 0 0 3.19"></path>
  </svg>
);

export default SvgIcon;
